import { makeVar } from '@apollo/client/core';
import isAdmin from '../../../Services/isAdmin';

// --- Category ---

export interface CategoryState {
  option: string;
  isLetterImagePaid: boolean;
  isOpenMenu: boolean;
  secondOption: string | null;
}

export const categoryVar = makeVar<CategoryState>({
  option: 'LETTER_BOX',
  isLetterImagePaid: false,
  isOpenMenu: false,
  secondOption: null,
});

// --- Selected Organization ---

export interface SelectedOrganizationState {
  id: number | null;
  legalName: string | null;
  missingDocuments: number;
  status: string | null;
  terminationReason: string | null;
  terminationDate: string | null;
  invoiceToken: string | null;
}

const getInitialSelectedOrgId = (): number | null => {
  if (typeof window === 'undefined') return null;
  const first = window.location.pathname.split('/')[1];
  if (first && first !== 'all' && !isNaN(+first)) {
    return +first;
  }
  return null;
};

export const selectedOrganizationVar = makeVar<SelectedOrganizationState>({
  id: getInitialSelectedOrgId(),
  legalName: null,
  missingDocuments: 0,
  status: null,
  terminationReason: null,
  terminationDate: null,
  invoiceToken: null,
});

// --- Configuration Guide ---

export interface ConfigurationGuideState {
  isOpen: boolean;
  isOpenManualy: boolean;
}

export const configurationGuideVar = makeVar<ConfigurationGuideState>({
  isOpen: !isAdmin(),
  isOpenManualy: false,
});

// --- Dialog Many Org ---

export interface DialogManyOrgState {
  isOpen: boolean;
}

export const dialogManyOrgVar = makeVar<DialogManyOrgState>({
  isOpen: false,
});
